// Atlas's mount point — the only thing App.js has to know about.
//
// One line in a 53,000-line file, on purpose. Everything else lives out here
// where it can be read, changed, and eventually tested without touching the
// application shell.
//
// The panel is lazy-loaded, so its code (and the conversation UI it carries)
// is not in the bundle every user downloads to reach a login screen. The
// launcher is small and lives here rather than in the panel, because importing
// it eagerly from there would pull the whole panel in and defeat the split.

import React, { Suspense, lazy, useState } from "react";

const AssistantPanel = lazy(() => import("./AssistantPanel"));

const BRAND = "var(--ed-brand)";

export default function Assistant({ facilityId = null }) {
  const [open, setOpen] = useState(false);
  // Mounted once opened, then kept mounted, so closing the panel does not throw
  // away the conversation. Somebody who closes it to look at a resident and
  // reopens it expects their question to still be there.
  const [everOpened, setEverOpened] = useState(false);

  const openPanel = () => { setEverOpened(true); setOpen(true); };

  return (
    <>
      {!open ? (
        <button
          type="button"
          onClick={openPanel}
          aria-label="Open Atlas"
          style={{
            position: "fixed", right: 20, bottom: 20, zIndex: 2999,
            display: "flex", alignItems: "center", gap: 8,
            background: BRAND, color: "var(--ed-canvas)", border: 0, borderRadius: 999,
            padding: "11px 18px", font: "inherit", fontSize: 13.5, fontWeight: 600,
            boxShadow: "0 6px 20px rgba(15,76,129,.32)", cursor: "pointer",
          }}
        >
          <span aria-hidden style={{ fontSize: 15, lineHeight: 1 }}>✦</span>
          Atlas
        </button>
      ) : null}

      {everOpened ? (
        // No fallback: the panel opening a beat late is better than a spinner
        // flashing over the screen someone is reading.
        <Suspense fallback={null}>
          <AssistantPanel open={open} onClose={() => setOpen(false)} facilityId={facilityId} />
        </Suspense>
      ) : null}
    </>
  );
}
